import { useState, useEffect, useRef } from 'react';
import Axios from "axios";
import { useLocation,Link } from 'react-router-dom';
import ReactPaginate from "react-paginate";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import LoadingSpinner from '../helpers/loadingspinner';
import ConsultantLayout from '../commonlayouts/consultantlayout';
import { GetJobRoles, ReattemptInterview, Searchfilter} from '../apiconstants/constants';
import nodataimg from "../assets/images/Nodata.jpg";
import Swal from 'sweetalert2';
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import Select from 'react-select';
import { useCountry } from '../contexts/countrycodecontext.js';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function formatDate(dateString) {
  return dateString.split('T')[0];
}

function strip_html_tags(str) {
  if ((str === null) || (str === 'undefined' || str === undefined))
    return false;
  else
    str = str.toString();
  str = str.replace(/<[^>]*>/g, '');
  return substring_str(str.replace('&nbsp;', '').replace('.&nbsp;', ''));
}

function substring_str(str) {
  if ((str === null) || (str === ' ' || str === undefined))
    return "";
  else
    str = str.toString();
  return str.substring(0, 50) + "...";
}

const GetInterviewCompletedCandidates = () => {
  let Guid = "";
  const guid = localStorage.getItem("guid");
  const employerGuid = localStorage.getItem("employerGuid");
  const token = localStorage.getItem("jwtToken");
  const roleID = localStorage.getItem("roleID");

  if (roleID == 3) {
    Guid = employerGuid;
  } else {
    Guid = guid;
  }
  const [offset, setOffset] = useState(0);
  const query = useQuery();
  const [fetchedData, setFetchedData] = useState([]); // Store the fetched data
  const [filteredData, setFilteredData] = useState([]); // Store the filtered data
  const [perPage] = useState(25);
  const [data, setData] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [candidateData, setCandidateData] = useState([]); // Changed to array
  const [isLoading, setIsLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showModal1, setShowModal1] = useState(false);
  const {  selectedCountry} = useCountry();
  const [currentVideoUrl, setCurrentVideoUrl] = useState('');
  const [searchInput, setSearchInput] = useState('');
  const videoRef = useRef(null);
  const [refresh, setRefresh] = useState(false);
  const [startDate, setStartDate] = useState(""); // Start date state
  const [endDate, setEndDate] = useState(""); // End date state
   const [rating, setRating] = useState([
            { ratingID: "0", ratingName: "0 - Not-Considerable", color: "red" }, // Light gray for empty
            { ratingID: "1", ratingName: "1 - Not-Considerable", color: "#dc3545" }, // Red
            { ratingID: "2", ratingName: "2 - Average Candidate", color: "#fd7e14" }, // Orange
            { ratingID: "3", ratingName: "3 - Considerable Candidate", color: "#2e9e0fff" }, // Yellow
            { ratingID: "4", ratingName: "4 - Preferable Candidate", color: "#238335ff" }, // Olive green
            { ratingID: "5", ratingName: "5 - Expert Candidate", color: "#0f530fff" }, // Dark green
          ]);

const [showIcon, setShowIcon] = useState('list');
const [viewType, setViewType] = useState('list'); // 'grid' or 'list'
const appliedfilter = localStorage.getItem("completedcandidateFilters")

const [excelData, setExcelData] = useState([]);
const fileType =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const fileExtension = ".xlsx";
const fileName = "Interview_Completed_CandidatesList"; 
const [showFilterModal,setShowFilterModal] = useState(false)
const [jobRoles, setJobRoles] = useState([]);
const [filters, setFilters] = useState({
  UserGuid: Guid,
  jobroleid : "",
  rating: "",
  UpdatedDate: null,  
  // CountryID:selectedCountry,
});
console.log("99 : selected country", selectedCountry)
const dateFilterOptions = [
  { value: "Past 7 days", label: "Past 7 days" },
  { value: "Past 30 days", label: "Past 30 days" },
  { value: "This month", label: "This month" },
  { value: "Past 6 months", label: "Past 6 months" },
  { value: "Past 1 year", label: "Past 1 year" }, // Default case
       { value: "Past 2 years", label: "Past 2 years" }, // Default case
      { value: "Past 3 years", label: "Past 3 years" }, // Default case
];
const [selectedDateFilter, setSelectedDateFilter] = useState(null);
const [ratingOptions] = useState([
  { value: "", label: "Select Rating" },
    { value: "0", label: "0 - Not-Considerable" },
    { value: "1", label: "1 - Not-Considerable" },
    { value: "2", label: "2 - Average Candidate" },
    { value: "3", label: "3 - Considerable Candidate" },
    { value: "4", label: "4 - Preferable Candidate" },
    { value: "5", label: "5 - Expert Candidate" },
]);
const getRatingName = (ratingID) => {
  const ratingItem = rating.find(r => r.ratingID == ratingID);
  return ratingItem ? ratingItem.ratingName : "0 - Not-Considerable";
}
const getRatingDetails = (ratingID) => {
  const ratingItem = rating.find(r => r.ratingID === ratingID?.toString());
  return ratingItem ? { name: ratingItem.ratingName, color: ratingItem.color } : { name: "0 - Not-Considerable", color: "#ed0b38ff" };
};
  const handlePageClick = (e) => {
    const selectedPage = e.selected;
    setOffset(selectedPage * perPage);
  };

  const handleViewToggle = (type) => {
    setViewType(type);
    setShowIcon(type)
  };


  const exportToCSV = async (fileName) => {            
        const payload = {
          json: JSON.stringify({UserGuid: Guid,CountryID:selectedCountry}),
          type: "completed",
          };
         const result =   Axios.post(Searchfilter.APIURL, payload,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
         )
            setIsLoading(false);
        
            if (!result.data || result.data.length === 0) {
              alert("No data available for export.");
              return;
            }
            const customHeadings = result.data?.filter((item)=> (item.isActive==false)).map(item=>({
              "Full Name": item.name,
              "Email": item.email,
              "Mobile Number":item.mobileNumber,
              "Gender": item.gender,
              "Address": item.address,
              "Date of Birth":item.dob,
              "Experience": item.experience,
              "Work Mode": item.workMode,
              "Work Authorization and Validity": item.workAuthorizationandValidity,
              "Job Role": item.jobRole,
              "Comments":item.comments,
              "Rating":item.rating,
            }))
    const ws = XLSX.utils.json_to_sheet(customHeadings);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  const handleReAttemptInterview = async (guid) => {
    const params = { guid };
  
    try {
      const result = await Axios.post(ReattemptInterview.APIURL, params, { headers: { Authorization: `Bearer ${token}` } });
  
      if (result.data === "Updated successfully") {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Now Candidate can Re-Attempt Test',
          showConfirmButton: false,
          timer: 5000
        });
  
        // Fetch updated list after success
      setFetchedData(prev => prev.filter(candidate => candidate.guiID != guid));
      }
    } catch (error) {
      console.error("Reattempt error:", error);
    }
  };
  
const fetchJobRoles = async () => {
  const getApiUrl = `${GetJobRoles.APIURL}?UserGuid=${Guid}&CountryID=${selectedCountry}`;
  try {
      const response = await Axios.get(getApiUrl);
      setJobRoles(response.data);
  } catch (error) {
      console.error("Error fetching job roles", error);
  }
};
  const GetCandidateList = () => {
    setIsLoading(true);
    const savedFilters = localStorage.getItem("completedcandidateFilters");
  let payload;

  if (savedFilters) {
    const parsedFilters = JSON.parse(savedFilters);
     parsedFilters.CountryID = selectedCountry;
    setFilters(parsedFilters); // Optional: sync with UI filters

    payload = {
      json: JSON.stringify(parsedFilters),
      type: "completed",
    };
  } else {
    // Default payload when no saved filters
    payload = {
      json: JSON.stringify({ UserGuid: Guid, CountryID: selectedCountry }),
      type: "completed",
    };
  }

     Axios.post(Searchfilter.APIURL, payload,
      { headers: { Authorization: `Bearer ${token}` }, }
     )
      .then((result) => {
        setIsLoading(false);
        setFetchedData(result.data?.filter((item)=> (item.isActive==false))); // Store the fetched data
        const customHeadings = result.data?.filter((item)=> (item.isActive==false)).map(item=>({
          "Full Name": item.name,
          "Email": item.email,
          "Mobile Number":item.mobileNumber,
          "Gender": item.gender,
          "Address": item.address,
          "Date of Birth":item.dob,
          "Experience": item.experience,
          "Work Mode": item.workMode,
          "Work Authorization and Validity": item.workAuthorizationandValidity,
          "Job Role": item.jobRole,
          "Comments":item.comments,
          "Rating":item.rating,
        }))
   
         setExcelData(customHeadings) 
      })
      .catch((error) => {
        console.log("Error" + error);
      });
  };

  const handleVideoClick = (videoURL) => {
    setCurrentVideoUrl(videoURL);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setCurrentVideoUrl('');
  };

  const handleForward = () => {
  const video = videoRef.current;
  if (video && video.duration) {
    video.currentTime = Math.min(video.currentTime + 10, video.duration);
  }
};

const handleRewind = () => {
  const video = videoRef.current;
  if (video) {
    video.currentTime = Math.max(video.currentTime - 10, 0);
  }
};

  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
    setOffset(0); // Reset pagination when filters change
  };

  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
    setOffset(0); // Reset pagination when filters change
  };

  const handleRefresh = () => {
    setStartDate("");
    setEndDate("");
    setSearchInput("");
    setOffset(0); // Reset pagination when filters change
    setFilters({
      UserGuid: Guid,
      jobroleid : "",
      UpdatedDate: null,
    });
     localStorage.removeItem("completedcandidateFilters");
    GetCandidateList();
  };

  const handleFilterSearch=()=>{
    setShowFilterModal(true);
    }
  const handleCancelSearch = () => {
    setShowFilterModal(false);
  }; 
  const jobRoleOptions = jobRoles.map((item) => ({
    value: item.jobRoleId,
    label: item.jobRole
  }));

  const handleJobRoleChange = (selectedOptions) => {
    // Convert selected options to a comma-separated string of labels
    const jobRolesLabels = selectedOptions.map((opt) => opt.value).join(", ");
    
    setFilters({ ...filters, jobroleid : jobRolesLabels });
  };
  const handleRatingChange = (selectedOption) => {
    
    setFilters((prevFilters) => ({
      ...prevFilters,
      rating: selectedOption.value, // ✅ Store label for API
    }));
  };
  
  const handleFilterChange = (selectedOption) => {
    setFilters({ ...filters, UpdatedDate: selectedOption.label });

  };
//   useEffect(() => {
//   setFilters(prev => {
//     const updatedFilters = { ...prev, CountryID: selectedCountry };
//     const cleaned = {
//       ...updatedFilters,
//       UpdatedDate: updatedFilters.UpdatedDate === "Select Date Filter" ? "" : updatedFilters.UpdatedDate,
//       rating: updatedFilters.rating === "Select Rating" ? "" : updatedFilters.rating,
//     };
//     localStorage.setItem("completedcandidateFilters", JSON.stringify(cleaned));
//     return updatedFilters;
//   });
// }, [selectedCountry]);
     const applyFilters = () => {
      const cleanedFilters = {
        ...filters,
        UpdatedDate: filters.UpdatedDate === "Select Date Filter" ? "" : filters.UpdatedDate,
        rating: filters.rating === "Select Rating" ? "" : filters.rating,
          CountryID: selectedCountry ,
      };
    
      // Remove empty values
      let filteredData = Object.fromEntries(
        Object.entries(cleanedFilters).filter(
          ([key, value]) =>
            value !== "" &&
            value !== null &&
            !(Array.isArray(value) && value.length === 0)
        )
      );
         localStorage.setItem("completedcandidateFilters", JSON.stringify(cleanedFilters));
          const payload = {
            json: JSON.stringify(filteredData),
            type: "completed",
           
          };
      
          console.log("Sending JSON:", payload);
          Axios
            .post(Searchfilter.APIURL, payload)
            .then((response) => {
              console.log("Success:", response.data);
            setShowFilterModal(false);
              if( response.data == "No Data"){
                setFetchedData([]);
              }
              else{
              setFetchedData(response.data.filter((item)=> (item.isActive==false)));
              }
            })
            .catch((error) => {
              console.error("Error:", error);
            });
        };
       

        const [selectedGuiID, setSelectedGuiID] = useState(null);

        const openModalWithGUID = (guiID) => {
          setSelectedGuiID(guiID);
          setShowModal1(true);
        };
      
        const handleConfirm = () => {
          if (selectedGuiID) {
            handleReAttemptInterview(selectedGuiID);
            setShowModal1(false);
            setSelectedGuiID(null);          
           
          }
        
        };
  useEffect(() => {
    GetCandidateList();
    fetchJobRoles();
  }, [selectedCountry]);

  useEffect(() => {
      const filteredData = fetchedData?.filter(candidate => {
      const name = candidate.name?.toLowerCase().includes(searchInput?.toLowerCase());
      const role = candidate.jobRole?.toLowerCase().includes(searchInput?.toLowerCase());
      const rating = candidate.rating?.toLowerCase().includes(searchInput?.toLowerCase());
      const comments = candidate.comments?.toLowerCase().includes(searchInput?.toLowerCase());
      return (name || role || rating || comments);
    });

    setCandidateData(filteredData);
    const slice = filteredData.slice(offset, offset + perPage);
    const items = viewType =='grid' ?  slice.map((data) => (
      <div className="col-sm-12 col-md-6 col-xl-4 col-lg-4 pb-3" key={data.guiID}>
        <div className="card" style={{ background: "#f8f8f8", border: '1px solid #00a7ac26', maxHeight: 520, height: 500, borderRadius: 20 }}>
          <div className='card-header' style={{ background: "none", minHeight: 170 }}>
            <div className='row'>
              <div className='col-8'>
                <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Name</Tooltip>)}>
                  <p className="card-title jb-head" style={{ color: "#00a7ac", fontSize: 24 }}><b>{data.name}</b></p>
                </OverlayTrigger>
                <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Job Role</Tooltip>)}>
                  <h5 style={{ fontSize: 18 }}>{data.jobRole}</h5>
                </OverlayTrigger>
              </div>
            </div>
          </div>
          <div className="card-body">
            <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}><span className="tooltip2">Email</span></Tooltip>)}>
              <p style={{ fontSize: 14, textAlign: 'justify' }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fa fa-envelope" aria-hidden="true"></i> {data.email}  </p>
            </OverlayTrigger>
            <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Test Date</Tooltip>)}>
              <p style={{ fontSize: 14 }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-calendar" aria-hidden="true"></i> {formatDate(data.startDate)} to {formatDate(data.endDate)}</p>
            </OverlayTrigger>
          {data.rating !== null && data.rating !== "null" &&
  <OverlayTrigger
    placement="bottom"
    overlay={(props) => (
      <Tooltip id="tooltip" {...props}>Rating</Tooltip>
    )}
  >
    {(() => {
      const { name, color } = getRatingDetails(data.rating);
      return (
        <p style={{ fontSize: 12, color, fontWeight: "bold", marginBottom: 10 }}>
          <i
            style={{ fontSize: 12, marginRight: 10 }}
            className="fas fa-star"
            aria-hidden="true"
          ></i>
          {name}
        </p>
      );
    })()}
  </OverlayTrigger>
}

                {data.comments !== null && data.comments !== "null" &&
                <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Comments</Tooltip>)}>
    <div style={{ fontSize: 14 }}>
        <i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-comment" aria-hidden="true"></i>
        {strip_html_tags(data.comments)}
    </div>
</OverlayTrigger>
  }


                <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Video</Tooltip>)}>
                <p style={{ fontSize: 18 }}>
                <i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-video" aria-hidden="true"></i> <a href="#!" onClick={() => handleVideoClick(data.videoURL)}>Click to View Video</a>
                </p>
                </OverlayTrigger>
                <div className='card-footer d-flex justify-content-between' style={{ background: "none" }}>
                <Link to={"/Employer/CommentInterviewCompletedCandidates?guid=" + data.guiID}>
                <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Add Review</Tooltip>)}>
                <button style={{ background: "none", border: "none" }}><i className="fa fa-edit" aria-hidden="true" style={{ fontSize: 20, color: "#00a7ac" }}></i></button>
                </OverlayTrigger>
                </Link>
                <Link to={"/Employer/ViewInterviewCompletedCandidateDetails?guid=" + data.guiID}>
                <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> View</Tooltip>)}>
                <button style={{ background: "none", border: "none" }}><i className="fa fa-eye" aria-hidden="true" style={{ fontSize: 20, color: "#00a7ac" }}></i></button>
                </OverlayTrigger>
                </Link>
                <Link to={"/Employer/ShareInterviewDetailstoVendor?guid=" + data.guiID}>
                <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Share</Tooltip>)}>
                <button style={{ background: "none", border: "none" }}><i className="fa fa-share-alt" aria-hidden="true" style={{ fontSize: 20, color: "#00a7ac" }}></i></button>
                </OverlayTrigger>
                </Link>
                <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Reattempt Interview</Tooltip>)}>
                <button onClick={() => handleReAttemptInterview(data.guiID)} style={{ background: "none", border: "none" }}><i className="fas fa-redo" aria-hidden="true" style={{ fontSize: 20, color: "#00a7ac" }}></i></button>
                </OverlayTrigger>
                </div>
                </div>
                </div>
                </div>
                )) :
                <div className="col-12" style={{ overflowX: "auto", width: "100%" }}>
                <table className="table"
  style={{
    minWidth: "100%",
    fontSize: "12px", // Reduced font size
    // tableLayout: "fixed",
    wordWrap: "break-word",
  }}>
                  <thead>
                    <tr>
                      <th>Full Name</th>
                      <th>Job Role</th>
                      <th>Email</th>
                      <th>Test Date</th>
                      <th>Rating</th>
                      <th>Comments</th>
                      <th>Video</th>
                      <th>Actions</th>
                      </tr>
                  </thead>
                  <tbody>
                     {slice?.map((data, index) =>{
            return ( 
                      <tr key={index}>
                        <td>{data.name}</td>
                        <td>{data.jobRole}</td>
                        <td>{data.email}</td>
                        <td>{formatDate(data.startDate)} to {formatDate(data.endDate)}</td>
                      <td style={{ color: getRatingDetails(data.rating).color, fontWeight: "bold", fontSize: 12}}>
  {getRatingDetails(data.rating).name}
</td>

                        <td>{strip_html_tags(data.comments)}</td>
                        <td style={{cursor:"pointer"}} onClick={() => handleVideoClick(data.videoURL)} >Click to View Video</td>
                       <td>  
                        <div style={{ display: "flex", gap: "5px", alignItems: "center" }}> 
                        <Link to={"/Employer/CommentInterviewCompletedCandidates?guid=" + data.guiID}>
                <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Add Review</Tooltip>)}>
                <button style={{ background: "none", border: "none" }}><i className="fa fa-edit" aria-hidden="true" style={{ fontSize: 14, color: "#00a7ac" }}></i></button>
                </OverlayTrigger>
                </Link>
                <Link to={"/Employer/ViewInterviewCompletedCandidateDetails?guid=" + data.guiID}>
                <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> View</Tooltip>)}>
                <button style={{ background: "none", border: "none" }}><i className="fa fa-eye" aria-hidden="true" style={{ fontSize: 14, color: "#00a7ac" }}></i></button>
                </OverlayTrigger>
                </Link>
                <Link to={"/Employer/ShareInterviewDetailstoVendor?guid=" + data.guiID}>
                <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Share</Tooltip>)}>
                <button style={{ background: "none", border: "none" }}><i className="fa fa-share-alt" aria-hidden="true" style={{ fontSize: 14, color: "#00a7ac" }}></i></button>
                </OverlayTrigger>
                </Link>
                <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Reattempt Interview</Tooltip>)} >
              <button   onClick={() => openModalWithGUID(data.guiID)} style={{ background: 'none', border: 'none' }} >
              <i  className="fas fa-redo"aria-hidden="true"style={{ fontSize: 14, color: '#00a7ac' }}></i>
              </button>
               </OverlayTrigger>
                {/* <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Reattempt Interview</Tooltip>)}>
                <button onClick={() => handleReAttemptInterview(data.guiID)} style={{ background: "none", border: "none" }}><i className="fas fa-redo" aria-hidden="true" style={{ fontSize: 14, color: "#00a7ac" }}></i></button>
                </OverlayTrigger> */}
            </div></td>
                       </tr>
                     )})}
                  </tbody>
                </table>
              </div>
    setData(items);
    setPageCount(Math.ceil(filteredData.length / perPage));
  }, [searchInput, startDate, endDate, fetchedData, offset, perPage,viewType]);

  return (
              <ConsultantLayout>
            
              <div className='container-fluid'>
              <div className='row mt-1'>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
  <h2 style={{ color: "#00a7ac" }}>List of Interview Completed Candidates </h2>
  <div style={{ display: 'flex', alignItems: 'center' }}>
  {/* <Link to="/TestVideo">
  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Test Video</Tooltip>)}> 
      <button className="btn btn-primary mr-3" type="button" >
        <i className="fa fa-play" style={{ fontSize: 16 }}></i>
      </button>
    </OverlayTrigger>
    </Link> */}
      {showIcon === 'grid' && (
                                                  <OverlayTrigger placement="bottom" overlay={<Tooltip>List View</Tooltip>}>
                                                    <button
                                                      className="btn btn-primary mr-3 mt-3"
                                                      onClick={() => handleViewToggle('list')}
                                                      style={{ backgroundColor: "#00a7ac",marginBottom:15}}
                                                    >
                                                      <i className="fa fa-th-list" style={{color: '#fff', cursor: 'pointer' }}></i>
                                                    </button>
                                                  </OverlayTrigger>
                                                )}
                                                {showIcon === 'list' && (
                                                  <OverlayTrigger placement="bottom" overlay={<Tooltip>Grid View</Tooltip>}>
                                                    <button
                                                      className="btn btn-primary mr-3 mt-3"
                                                      onClick={() => handleViewToggle('grid')}
                                                      style={{ backgroundColor: "#00a7ac",marginBottom:15, }}
                                                    >
                                                      <i className="fa fa-th" style={{ color: '#fff', cursor: 'pointer'}}></i>
                                                    </button>
                                                  </OverlayTrigger>
                                                )}
    {(roleID === "2") &&                                            
    <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Export To Excel</Tooltip>)}>
      <button className="btn btn-primary mr-3" onClick={(e) => exportToCSV(fileName)} type="button" >
        <i className="fas fa-file-excel" style={{ fontSize: 16 }}></i>
      </button>
    </OverlayTrigger>
}
    <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Configure Screening Test</Tooltip>)}>
      <Link to="/Employer/NonHiredCandidates">
        <button className="btn btn-primary" type="button"><i className="fa fa-plus"></i></button>
      </Link>
    </OverlayTrigger>
  </div>
</div>

              </div>
              <div className="row d-flex justify-content-between mt-1">
      <div className="col">
        <OverlayTrigger placement="bottom" overlay={(props) => (
          <Tooltip id="tooltip" {...props}>Search by Name or Job Role or Rating or Comments</Tooltip>
        )}>
          <input
            type='text'
            placeholder='Search by Name or Job Role or Rating or Comments'
            value={searchInput}
            onChange={(e) => { setSearchInput(e.target.value); setOffset(0); }}
            className='form-control mt-1'
           // id="searchvendor"
          />
        </OverlayTrigger>
      </div>

      <div className="col-auto align-self-end">
      
               <Link>
                  <OverlayTrigger placement="bottom" overlay={(props) => (
                    <Tooltip id="tooltip" {...props}> { appliedfilter == null ? "Apply Filter" : "Filter Applied" }</Tooltip>
                  )}>
                  <button className="btn btn-primary mt-1 mr-3" onClick={handleFilterSearch} style={{height:50}}type="button">
                  <i className="fas fa-filter"></i>  { appliedfilter == null ? "Apply Filter" : "Filter Applied" }
                  </button>
                  </OverlayTrigger>
                  </Link>
                  <Link>
                  <OverlayTrigger placement="bottom" overlay={(props) => (
                    <Tooltip id="tooltip" {...props}>Reset</Tooltip>
                  )}>
                  <button className="btn btn-primary mt-1" onClick={handleRefresh} style={{height:50}}type="button">
                    <i className="fas fa-sync"></i> Reset Filter
                  </button>
                  </OverlayTrigger>
                  </Link>
      </div>
    </div>

    <hr />
    {isLoading ? (
          <center><LoadingSpinner /></center>
        ) : (
          <>
            {candidateData.length > 0 ? (
              <div className="row mt-5 pb-3">
                {data}
              </div>
            ) : (
              <div className="pb-5 text-center">
                <img title='No Data' className='no-data-img' alt="no-data-img" src={nodataimg} style={{ height: 370 }} />
              </div>
            )}
          </>
        )}
    {candidateData.length > perPage && (
      <ReactPaginate
        previousLabel={"Prev"}
        nextLabel={"Next"}
        breakLabel={"..."}
        breakClassName={"break-me"}
        pageCount={pageCount}
        marginPagesDisplayed={2}
        pageRangeDisplayed={10}
        onPageChange={handlePageClick}
        containerClassName={"pagination"}
        subContainerClassName={"pages pagination"}
        activeClassName={"active"}
        disabledClassName={"disable-pagination-button"}
      />
    )}
  </div>
            <Modal show={showModal} onHide={handleClose} centered>
              <Modal.Header closeButton style={{ borderBottom: 'none' }}>
              </Modal.Header>
              <Modal.Body style={{ padding: 0, overflow: 'hidden' }}>
{/*                 
               <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <video autoplay loop muted playsinline ref={videoRef} width="100%" height="90%" controls>
                <source src={currentVideoUrl} type="video/webm" />
                    Your browser does not support the video tag.
                  </video>
                  <div style={{ marginTop: 10 }}>
                    <OverlayTrigger placement="top" overlay={<Tooltip>Rewind 10sec</Tooltip>}>
                      <button onClick={handleRewind} style={{ background: "none", border: "none", marginRight: 10 }}>
                        <i className="fas fa-undo" style={{ fontSize: 20, color: "#00a7ac" }}></i>
                      </button>
                    </OverlayTrigger>
                    <OverlayTrigger placement="top" overlay={<Tooltip>Forward 10sec</Tooltip>}>
                      <button onClick={handleForward} style={{ background: "none", border: "none", marginRight: 10 }}>
                        <i className="fas fa-redo" style={{ fontSize: 20, color: "#00a7ac" }}></i>
                      </button>
                    </OverlayTrigger>
                    <OverlayTrigger placement="top" overlay={<Tooltip>Download Video</Tooltip>}>
                      <a href={currentVideoUrl} download>
                        <i className="fas fa-download" style={{ fontSize: 20, color: "#00a7ac" }}></i>
                      </a>
                    </OverlayTrigger>
                  </div>
                </div>  */}
                <div className="iframe-container" style={{width:'100%',height:'400px'}}>
                  <iframe 
                    src={currentVideoUrl} 
                    sandbox="allow-scripts allow-same-origin" 
                    className="responsive-iframe" 
                    allow="autoplay"
                  ></iframe>
                </div>
              </Modal.Body>
            </Modal>
  
  <Modal show={showFilterModal} style={{ textAlign: 'center'}} dialogClassName="custom-modal" onHide={handleCancelSearch}>
              <Modal.Header closeButton>
                <Modal.Title style={{color:"#00a7ac"}}>filters </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                             <div className='row'>
                                 
                                   <div className='col-6'>
                                        
                          <Select
                              options={dateFilterOptions}
                              placeholder="Select Date Filter"
                              value={dateFilterOptions.find(option => option.label === filters.UpdatedDate) || null}
                              onChange={handleFilterChange}
                              className="mt-3"
                              styles={{
                                control: (provided) => ({
                                  ...provided,
                                  height: 50,
                                  borderRadius: 10,
                                  fontSize: "12px",
                                }),
                                placeholder: (provided) => ({
                                  ...provided,
                                  textAlign: "left",
                                  fontSize: "12px",
                                }),
                                singleValue: (provided) => ({
                                  ...provided,
                                  textAlign: "left",
                                  fontSize: "12px",
                                }),
                              }}
                            />
                               <Select
                                    options={ratingOptions} // Pass formatted options
                                    placeholder="Select Rating"
                                    className="mt-3"
                                    value={ratingOptions.find(option => option.value === filters.rating) || null} 
                                    onChange={handleRatingChange} // Handle selection
                                    styles={{
                                      control: (provided) => ({
                                        ...provided,
                                        height: 50,
                                        borderRadius: 10,
                                        fontSize: "12px",
                                      }),
                                      placeholder: (provided) => ({
                                        ...provided,
                                        textAlign: "left",
                                        fontSize: "12px",
                                      }),
                                      singleValue: (provided) => ({
                                        ...provided,
                                        textAlign: "left",
                                        fontSize: "12px",
                                      }),
                                    }}
                                  />
                            </div>
                            <div className='col-6'>
                            <Select
                                    options={jobRoleOptions}
                                    isMulti
                                    placeholder="Select Job Roles"
                                    className="mt-3"
                                    value={jobRoleOptions.filter(option => 
                                      filters.jobroleid.split(", ").includes(option.value.toString()) // ✅ Convert stored string back to array
                                    )}
                                    onChange={handleJobRoleChange}
                                    styles={{
                                      control: (provided) => ({
                                        ...provided,
                                        height: 115,
                                        borderRadius: 10,
                                        fontSize: "12px",
                                      }),
                                      placeholder: (provided) => ({
                                        ...provided,
                                        textAlign: "left",
                                        fontSize: "12px",
                                      }),
                                      singleValue: (provided) => ({
                                        ...provided,
                                        textAlign: "left",
                                        fontSize: "12px",
                                      }),
                                    }}
                                  />
                                    
                                   </div>
                             </div>
                            
                           </Modal.Body>
                           <Modal.Footer style={{marginTop:100}}>
                     <Button variant="primary" onClick={handleRefresh}>
                   <i className="fas fa-sync" style={{ marginRight: "5px" }}></i> Reset
                 </Button>
                       <Button variant="primary" onClick={applyFilters}>Apply</Button>
                       <Button variant="secondary" onClick={handleCancelSearch}>Cancel</Button>
             
                     </Modal.Footer>
            </Modal>
            <Modal show={showModal1} onHide={() => setShowModal1(false)} centered>
     
        <Modal.Body>
          Are you sure you want to reattempt this interview?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal1(false)}  >
            Cancel
          </Button>
          <Button variant="primary" onClick={handleConfirm}>
            OK
          </Button>
        </Modal.Footer>
             </Modal>
  
</ConsultantLayout>
);
};

export default GetInterviewCompletedCandidates;